import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createContext, useContext } from 'react';
import { TableActionType } from 'src/types/crudTable';
export var TableContext = /*#__PURE__*/createContext(null);
export function useTableContext() {
  var context = useContext(TableContext);

  if (!context) {
    throw new Error('useTableContext must be used within TableProvider');
  }

  var state = context.state,
      dispatch = context.dispatch,
      table = context.table;
  return _objectSpread(_objectSpread({}, state), {}, {
    table: table,
    // Computed
    hasChanges: Object.keys(state.changes).length > 0,
    selectedRows: table.getSelectedRowModel().rows,
    // Operations
    setMode: function setMode(mode) {
      return dispatch({
        type: TableActionType.SET_MODE,
        payload: mode
      });
    },
    updateCell: function updateCell(rowId, columnId, value) {
      return dispatch({
        type: TableActionType.UPDATE_CELL,
        payload: {
          rowId: rowId,
          columnId: columnId,
          value: value
        }
      });
    },
    bulkUpdate: function bulkUpdate(columnId, value) {
      return dispatch({
        type: TableActionType.BULK_UPDATE,
        payload: {
          columnId: columnId,
          value: value,
          selectedRows: table.getSelectedRowModel().rows.map(function (row) {
            return row.id;
          })
        }
      });
    },
    setPage: function setPage(pageIndex) {
      return dispatch({
        type: TableActionType.SET_PAGE,
        payload: pageIndex
      });
    },
    setSort: function setSort(sorting) {
      return dispatch({
        type: TableActionType.SET_SORTING,
        payload: sorting
      });
    }
  });
}